import { connect, ConnectedProps } from "react-redux";
import { RootState } from "./store/store"; // Assuming your store file is named 'store.ts'

import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import CorePage from "./pages/CorePage";
import { notification, Spin } from "antd";
import { refresh } from "./store/actions/user";
import { useEffect } from "react";
import { notificationActions } from "./store/slices/notification";
import DashboardPage from "./pages/DashboardPage";

import { fetchData } from "./store/actions/cms";
import { PATH_API_MANAGE, PATH_LOOKUP } from "./config";

import ExpensePage from "./pages/ExpensePage";
import LotteryProviderPage from "./pages/LotteryProviderPage";
import BackgroundPage from "./pages/BackgroundPage";
import UsersPage from "./pages/UsersPage";
import NotificationPage from "./pages/NotificationPage";
import RevertSoldPage from "./pages/RevertSoldPage";
import TransferPackPage from "./pages/TransferPackPage";
import ProfilePage from "./pages/ProfilePage";
import PaymentHistoryPage from "./pages/PaymentHistoryPage";
import PaymentFallback from "./pages/PaymentFallback";
import StoreDashboardPage from "./pages/StoreDashboardPage";
import InventoryPage from "./pages/InventoryPage";
import PacksPage from "./pages/PacksPage";
import ReportPage from "./pages/ReportPage";
import { useSocket } from "./hooks/useSocket";
import { triggerNotification } from "./store/directActions";
import fetchStats from "./utils/fetchStats";
import { userActions } from "./store/slices/user";
import ShiftManagementPage from "./pages/ShiftManagementPage";
import EndShiftPage from "./pages/EndShiftPage";
import PageScreenV3 from "./pages/PageScreenV3";
import RefeshAlert from "./components/Notification";
import useAudio from "./utils/useAudio";
import moment from "moment";

const sounds = {
  error:
    "https://soundbible.com/mp3/Computer%20Error%20Alert-SoundBible.com-783113881.mp3",
  success: "https://soundbible.com/mp3/Bleep-SoundBible.com-1927126940.mp3",
};

interface OwnProps {
  setTheme?: (theme: "light" | "dark") => void;
  theme?: "light" | "dark";
}

type CorePageProps = OwnProps & PropsFromRedux;

const RouterFile: React.FC<CorePageProps> = ({
  isLoggedIn,
  profileData,
  isInitialLoading,
  refresh,
  lookup,
  notificationData,
  resetNotification,
  roleType,
  userId,
  logout,
  setTheme,
  theme,
}) => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: isLoggedIn ? (
        // !profileData?.isEmploy ? (
        //   <OnboardPage />
        // ) : (
        <CorePage setTheme={setTheme} theme={theme} />
      ) : (
        // )
        <Navigate to="/login" />
      ),
      children: [
        {
          index: true,
          element: roleType === 1 ? <DashboardPage /> : <StoreDashboardPage />,
        },
        { path: "lottery", element: <ExpensePage /> },
        { path: "organiser", element: <LotteryProviderPage /> },
        { path: "backgrounds", element: <BackgroundPage /> },
        { path: "users", element: <UsersPage /> },
        { path: "notification", element: <NotificationPage /> },
        { path: "startshift", element: <ShiftManagementPage /> },
        { path: "endshift", element: <EndShiftPage /> },
        { path: "revert-sold", element: <RevertSoldPage /> },
        { path: "transfer-pack", element: <TransferPackPage /> },
        { path: "profile", element: <ProfilePage /> },

        // store pages
        { path: "payment-history", element: <PaymentHistoryPage /> },
        { path: "inventory", element: <InventoryPage /> },
        { path: "packs", element: <PacksPage /> },
        { path: "reports", element: <ReportPage /> },
      ],

      // .filter(
      //   (route) =>
      //     route.index === true ||
      //     (route.path &&
      //       Array.isArray(menu[route.path]) &&
      //       menu[route.path].length > 1) // OR if path exists in menu and has array length > 1
      // ),
    },

    { path: "live-display", element: <PageScreenV3 /> },
    { path: "staff-display", element: <PageScreenV3 is_staff={true} /> },
    {
      path: "payments/fallback",
      element: <PaymentFallback profileData={profileData} />,
    },
    {
      path: "/login",
      element: !isLoggedIn ? <LoginPage /> : <Navigate to="/" />,
    },
    {
      path: "*",
      element: !isLoggedIn ? <Navigate to="/login" /> : <Navigate to="/" />,
    },
  ]);

  useEffect(() => {
    refresh();
    // lookup();
  }, []);
  // @ts-ignore
  const [playing, toggle] = useAudio(sounds[1]);

  useEffect(() => {
    if (notificationData.show && notificationData.type) {
      const type = notificationData.type!;
      // @ts-ignore
      if (sounds[type]) {
        toggle({
          status: true,
          url: sounds[type],
          isLoop: false,
          sequence: moment().valueOf(),
        });
      }
      // @ts-ignore
      notification[type]({
        message: notificationData.title,
        description: notificationData.description,
        placement: "bottomLeft",
        duration: notificationData.duration ?? 5,
        pauseOnHover: false,
      });
    }

    setTimeout(() => {
      resetNotification();
    }, 3000);
  }, [notificationData.show]);

  // Setup socket connection with automatic room joining and subscriptions
  useSocket({
    rooms: userId && isLoggedIn ? userId : null,
    subscriptions: {
      "general-update": (data: any) => {
        if (data.topic === "notify" && roleType !== 1) {
          triggerNotification({
            type: data?.message?.type ?? "success",
            title: data?.message?.subject ?? "",
            description: data?.message?.description ?? "",
            duration: data?.message?.duration ?? 60,
          });
        }
        if (data.topic === "refresh") {
          // @ts-ignore
          window.location.reload(true);
        }
      },
      "store-update": async (data: any) => {
        if (data.topic === "logout") {
          await fetchStats("logout");
          logout();
        }
        if (data.topic === "refresh") {
          await fetchStats("refresh");
          // await updateVersion();
        }
        if (data.topic === "hardRefresh") {
          await fetchStats("hardRefresh");
          // @ts-expect-error
          window.location.reload(true);
        }
        if (data.topic === "stats") {
          console.log("stats event recieved");
          await fetchStats("stats");
        }
        if (data.topic === "notify" && roleType !== 1) {
          triggerNotification({
            type: data?.message?.type ?? "success",
            title: data?.message?.subject ?? "",
            description: data?.message?.description ?? "",
            duration: data?.message?.duration ?? 60,
          });
        }
      },
    },
    autoJoin: true,
    autoCleanup: true,
  });

  if (isInitialLoading) {
    return (
      <div className="w-full h-screen flex justify-center items-center">
        <Spin />
      </div>
    );
  }

  return (
    <>
      <RefeshAlert userId={userId} />
      <RouterProvider router={router} />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: state?.user?.isLoggedIn,
  profileData: state?.user?.profileData,
  userId: state?.user?.profileData?.data?.id,
  menu: state?.user?.profileData?.menu ?? {},
  isInitialLoading: state?.notification?.isInitialLoading,
  notificationData: state?.notification?.notificationData ?? {},
  roleType: state.user.roleType,
});

const mapDispatchToProps = (dispatch: any) => ({
  refresh: () => dispatch(refresh()),
  logout: () => dispatch(userActions.logout()),
  lookup: () =>
    dispatch(
      fetchData(PATH_API_MANAGE, PATH_LOOKUP, {}, "lookup", undefined, false),
    ),
  // @ts-ignore
  resetNotification: () => dispatch(notificationActions.toggleNotification()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(RouterFile);
